import React from 'react';
import { useOrderQuotationAccountInputQuery } from '../../../../../../../../services';
import { RhSingleAutocomplete } from '../../../../../../../dum';
import { IOrderQuotation } from '../../order-quotation-form';
import {
    ORDER_REQUEST_FIELD_LABELS,
    shortLabel,
} from '../../../../../../../../helpers';

export function AccountInput() {
    const inputName: keyof IOrderQuotation = 'account_id';
    const { data } = useOrderQuotationAccountInputQuery();

    const accounts = data?.getAccounts || [];

    // Unlike pedidos, the product picker is NOT scoped to the account catalog
    // (a cotización may quote products absent from the client's list — that is
    // the point). So switching the account does not invalidate the lines.
    return (
        <RhSingleAutocomplete
            itemText={'name'}
            itemValue={'id'}
            name={inputName}
            label={shortLabel(ORDER_REQUEST_FIELD_LABELS.account_id)}
            options={accounts}
        />
    );
}
